// import React, { useEffect } from 'react';
// import axios from 'axios';
// import { useParams } from 'react-router-dom';

// export default function Aktivierungslink() {
//   const { id } = useParams();
//   console.log("UUID in Aktivierungslink:", id);

//   useEffect(() => {
//     activateLink();
//   }, []);

//   function activateLink() {
//     const baseUrl = process.env.REACT_APP_API_URL;
//     const apiUrl = `/items/buchung?filter[activationlink][_eq]=${id}`;

//     axios.get(baseUrl + apiUrl)
//       .then(response => {
//         const buchungData = response.data.data;
//         console.log("Filtered buchung data:", buchungData);
//         if (buchungData.length > 0) {
//           const buchungId = buchungData[0].id;
//           updateIsConfirmed(buchungId);
//         } else {
//           console.log("No buchung found for activationlink:", id);
//         }
//       })
//       .catch(error => {
//         console.error('Error fetching buchung:', error);
//       });
//   }

//   function updateIsConfirmed(buchungId) {
//     const baseUrl = process.env.REACT_APP_API_URL;
//     const apiUrl = `/items/buchung/${buchungId}`;

//     const requestBody = {
//       is_confirmed: true
//     };

//     axios.patch(baseUrl + apiUrl, requestBody)
//       .then(response => {
//         console.log("Buchung updated successfully:", response.data);
//       })
//       .catch(error => {
//         console.error('Error updating buchung:', error);
//       });
//   }

//   return (
//     <div>
//       <p>aktivierungslink with id: {id}</p>
//     </div>
//   );
// }


// import React, { useEffect } from 'react';
// import axios from 'axios';
// import { useParams } from 'react-router-dom';

// export default function Aktivierungslink() {
//   const { id } = useParams();
//   console.log("UUID in Aktivierungslink:", id);

//   useEffect(() => {
//     activateLink();
//   }, []);

//   function activateLink() {
//     const baseUrl = process.env.REACT_APP_API_URL;
//     const apiUrl = `/items/buchung?filter[activationlink][_eq]=${id}`;

//     axios.get(baseUrl + apiUrl)
//       .then(response => {
//         const buchungData = response.data.data;
//         console.log("Filtered buchung data:", buchungData);
//         if (buchungData.length > 0) {
//           const buchungId = buchungData[0].id;
//           updateIsConfirmed(buchungId);
//         } else {
//           console.log("No buchung found for activationlink:", id);
//         }
//       })
//       .catch(error => {
//         console.error('Error fetching buchung:', error);
//       });
//   }

//   function updateIsConfirmed(buchungId) {
//     const baseUrl = process.env.REACT_APP_API_URL;
//     const apiUrl = `/items/buchung/${buchungId}`;

//     const requestBody = {
//       is_confirmed: true
//     };

//     axios.patch(baseUrl + apiUrl, requestBody)
//       .then(response => {
//         console.log("Buchung updated successfully:", response.data);
//         setTimeout(() => {
//           window.location.href = "/"; 
//         }, 5000);
//       })
//       .catch(error => {
//         console.error('Error updating buchung:', error);
//       });
//   }

//   return (
//     <div style={{ textAlign: 'center', marginTop: '50px' }}>
//       <h2>Danke für Ihre Buchung!</h2>
//       <p>Unser Moderator wird sich in Kürze mit Ihnen in Verbindung setzen.</p>
//     </div>
//   );
// }


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

export default function Aktivierungslink() {
  const { id } = useParams();
  console.log("UUID in Aktivierungslink:", id);
  const [confirmationMessage, setConfirmationMessage] = useState('');

  useEffect(() => {
    activateLink();
  }, []);

  function activateLink() {
    const baseUrl = process.env.REACT_APP_API_URL;
    const apiUrl = `/items/buchung?filter[activationlink][_eq]=${id}`;

    axios.get(baseUrl + apiUrl)
      .then(response => {
        const buchungData = response.data.data;
        console.log("Filtered buchung data:", buchungData);
        if (buchungData.length > 0) {
          const buchung = buchungData[0];
          if (!buchung.is_confirmed) {
            updateIsConfirmed(buchung.id);
            setConfirmationMessage('Danke für Ihre Buchung! Unser Moderator wird sich in Kürze mit Ihnen in Verbindung setzen.');
          } else {
            setConfirmationMessage('Ihre Buchung wurde bereits bestätigt. Vielen Dank!');
          }
        } else {
          console.log("No buchung found for activationlink:", id);
        }
        setTimeout(() => {
          window.location.href = '/'; 
        }, 5000);
      })
      .catch(error => {
        console.error('Error fetching buchung:', error);
      });
  }

  function updateIsConfirmed(buchungId) {
    const baseUrl = process.env.REACT_APP_API_URL;
    const apiUrl = `/items/buchung/${buchungId}`;

    const requestBody = {
      is_confirmed: true
    };

    axios.patch(baseUrl + apiUrl, requestBody)
      .then(response => {
        console.log("Buchung updated successfully:", response.data);
      })
      .catch(error => {
        console.error('Error updating buchung:', error);
      });
  }

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h2>{confirmationMessage}</h2>
    </div>
  );
}
